import store from "@/store";
import WebLoginAccount from "@/interfaces/WebLogin/WebLoginAccount";

/**
 * Identifies the account a read was issued for. A grower can switch accounts while a read is still in flight, and
 * a customer identifier repeats across entity databases, so the entity is part of the key as well as the customer.
 */
export function getAccountKey(account: WebLoginAccount | undefined): string {
  return `${account?.entityId ?? ""}|${account?.id ?? ""}`;
}

export function getSelectedAccountKey(): string {
  return getAccountKey(store.getters.webLoginModule.selectedAccount);
}

/** False once the grower has moved on, which is the signal to drop a reply rather than show it. */
export function isSelectedAccountKey(key: string): boolean {
  return key === getSelectedAccountKey();
}
